import React from 'react';
import styles from './MobilePodiumCard.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

export const MobilePodiumCard = ({ rank, name, statValue, country, flagUrl, photoUrl }) => (
  <div className={styles.card}>
    <div className={styles.leftContent}>
      <div className={styles.avatarWrap}>
        <span className={styles.rankNumber}>{rank}</span>
      </div>

      <div className={styles.playerInfo}>
        <span className={styles.name}>{renderMaxLengthText(name, 21)}</span>
        <span className={styles.value}>{statValue ?? '0000'}</span>
        <div className={styles.countryRow}>
          {flagUrl && (
            <div className={styles.flagWrap}>
              <img src={flagUrl} alt={country} className={styles.flagImg} />
            </div>
          )}
          <span className={styles.countryName}>{country}</span>
        </div>
      </div>
    </div>

    <div className={styles.photoWrap}>
      {photoUrl
        ? <img src={photoUrl} alt={name} className={styles.photo} />
        : <div className={styles.photoPlaceholder} />
      }
    </div>
  </div>
);
